export default __webpack_public_path__ + "static/media/FATICAMENTALE_ICONA.20c6641e.svg";